import { ADD_BANK, DELETE_BANK, GET_BANKS, UPDATE_BANK, UPDATE_BANK_STATUS } from "../types";


const initialState = {list: [], single: null, cities: []};

const reducer = (state = initialState, action) => {
    const {type, payload} = action;

    switch (type) {
        case GET_BANKS:
            return {...state, list: payload};

        case UPDATE_BANK:
            return {
                ...state,
                list: state.list.map((item) =>
                    item.id === payload.id ? payload : item
                ),
            };
        
        case UPDATE_BANK_STATUS:
            return {
                ...state,
                list: state.list.map((item) =>
                    item.id === payload.id ? payload : item
                ),
            };

        case ADD_BANK:
            return {
                ...state,
                list: [payload, ...state.list],
            };

        case DELETE_BANK:
            return {
                ...state,
                list: state.list.filter((item) => item.id !== payload.id),
            };

        default:
            return state;
    }
};

export default reducer;
